<template>
  <div class="festivalPage">
    <epidemic v-if="query && query.choiceIndex == 2"></epidemic>

    <!--div class="tabs iphone-x" v-if="showTab && tabList">
      <div class="fx-row">
        <div class="fx-1" :class="[item.style, index == choiceIndex ? 'active':'']" v-for="(item, index) of tabList"
             :key="index" @click="onTab(index)">{{item.name}}
        </div>
      </div>
    </div-->

    <active-over v-else></active-over>
  </div>
</template>

<script>
  //mixin
  import setNavigationTitle from "@/mixins/setNavigationTitle";
  import setNavigationBarColor from "@/mixins/setNavigationBarColor";
  import scrollTop from '@/mixins/scrollTop';
  //component
  //import festivalCalendar from "../calendar/pages/home/index";
  //import lightUpHometown from "../lightUpHometown/pages/home/index";
  import epidemic from "../epidemic/pages/index";
  import ActiveOver from "@/components/activeOver";

  export default {
    name: "festivalCalendar2021",
    data() {
      return {
        query: this.$route.query,
        tabList: [],
        choiceIndex: 0,
        showTab: true,
        dataNum: ""
      };
    },
    components: {
      //festivalCalendar,
      //lightUpHometown,
      epidemic,
      ActiveOver
    },
    mixins: [setNavigationTitle, setNavigationBarColor, scrollTop],
    methods: {
      onTab(index) {
        this.choiceIndex = index;

        this.scrollTop(0)
        this.changeTabTitle();
        this.changeTabColoe();
      },
      changeTabTitle() {
        if (this.query && this.query.choiceIndex == 1) {
          this.setNavigationTitle("领500元");
        } else if (this.query && this.query.choiceIndex == 2) {
          this.setNavigationTitle("出行防疫指南");
        } else {
          this.setNavigationTitle("返程车票提前抢");
        }
      },
      changeTabColoe() {
        if (this.query && this.query.choiceIndex == 1) {
          this.setNavigationBarColor("255,55,79,1");
        } else {
          this.setNavigationBarColor("255,255,255,1");
        }
      },
      changeTab(value) {
        this.showTab = value
      }
    },
    created() {
      // this.changeTabTitle();
      // this.dataNum=new Date().toLocaleDateString()
      // this.dataNum='2021/1/14'
    },
    activated() {
      this.changeTabTitle();
      this.changeTabColoe();
    }
  };
</script>

<style lang="scss" scoped>
  @import "~@/scss/mixin";

  $imgUrl: "https://cdn.133.cn/gtgjwap/Image/festivalActivity/";

  .festivalPage {
    position: relative;
    min-height: 100%;
    // display: flex;

    .tabs {
      width: 100%;
      background-color: #ffffff;
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 666;

      > div {
        > div {
          height: pxTo(52);
          text-align: center;
          padding-top: pxTo(33);
          background-size: pxTo(28) pxTo(28) !important;
          background-position: center pxTo(5) !important;

          @include fs-l-w-c(10, 10, 400);

          &.c {
            @include bg($imgUrl, "tab1");
          }

          &.l {
            @include bg($imgUrl, "tab2");
          }

          &.e {
            @include bg($imgUrl, "tab3");
          }

          &.active {
            &.c {
              @include bg($imgUrl, "tab1-active");
            }

            &.l {
              @include bg($imgUrl, "tab2-active");
            }

            &.e {
              @include bg($imgUrl, "tab3-active");
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/projects/festivalActivity/home/index.vue